import { useDeployProcess } from "./useDeployProcess";

const PUBLISHING_DEPLOY_PROCESSES = [
  "sync_and_sms",
  "edit_sync_and_sms",
] as const;

export const useHasPublishedChargeSchedules = () => {
  const deployProcess = useDeployProcess();
  return PUBLISHING_DEPLOY_PROCESSES.some(
    (process) => process === deployProcess
  );
};
